export const SIGNSANDSYMPTOMS = [
  {
    id: 'fever',
    name: 'staticPages.signsAndSymptoms.child.fever.name',
    image: 'Fever',
    steps: {
      intro: {
        mascot: 'whatIs',
        text: 'staticPages.signsAndSymptoms.child.fever.intro',
        definition: 'staticPages.signsAndSymptoms.child.fever.definition',
      },
      whatHelps: {
        mascot: 'whatToDo',
        question: 'staticPages.signsAndSymptoms.child.fever.whatHelps.question',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'DrinkWater',
            label: 'staticPages.signsAndSymptoms.child.fever.whatHelps.options.option1',
            icon: 'DrinkWater',
          },
          {
            id: 'LightClothes',
            label: 'staticPages.signsAndSymptoms.child.fever.whatHelps.options.option2',
            icon: 'LightClothes',
          },
          {
            id: 'Rest',
            label: 'staticPages.signsAndSymptoms.child.fever.whatHelps.options.option3',
            icon: 'Rest',
          },
          {
            id: 'WetCloth',
            label: 'staticPages.signsAndSymptoms.child.fever.whatHelps.options.option4',
            icon: 'WetCloth',
          },
        ],
      },
      whenToSay: {
        mascot: 'whenToWorry',
        question: 'staticPages.signsAndSymptoms.child.fever.whenToSay.question',
        stepcolors: ['#FF2B26', '#FF8A00', '#FF8A00', '#FF8A00', '#FF2B26', '#FF2B26'],
        options: [
          {
            id: 'CantBreath',
            label: 'staticPages.signsAndSymptoms.child.fever.whenToSay.options.option1',
            icon: 'CantBreath',
          },
          {
            id: 'shaking',
            label: 'staticPages.signsAndSymptoms.child.fever.whenToSay.options.option2',
            icon: 'Shaking',
          },
          {
            id: 'Sleepy',
            label: 'staticPages.signsAndSymptoms.child.fever.whenToSay.options.option3',
            icon: 'Sleepy',
          },
          {
            id: 'rash',
            label: 'staticPages.signsAndSymptoms.child.fever.whenToSay.options.option4',
            icon: 'Rash',
          },
          {
            id: 'CantDrink',
            label: 'staticPages.signsAndSymptoms.child.fever.whenToSay.options.option5',
            icon: 'CantDrink',
          },
          {
            id: 'NoPeeing',
            label: 'staticPages.signsAndSymptoms.child.fever.whenToSay.options.option6',
            icon: 'NoPeeing',
          },
        ],
      },
      quizMCQ1: {
        mascot: 'askingQuickCheck',
        intro: 'staticPages.signsAndSymptoms.child.fever.quiz1.intro',
        question: 'staticPages.signsAndSymptoms.child.fever.quiz1.question',
        answer: 'staticPages.signsAndSymptoms.child.fever.quiz1.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'warm',
            label: 'staticPages.signsAndSymptoms.child.fever.quiz1.options.option1',
            icon: 'Warm',
            correct: false,
          },
          {
            id: 'hot',
            label: 'staticPages.signsAndSymptoms.child.fever.quiz1.options.option2',
            icon: 'Hot',
            correct: true,
          },
          {
            id: 'cold',
            label: 'staticPages.signsAndSymptoms.child.fever.quiz1.options.option3',
            icon: 'Cold',
            correct: false,
          },
          {
            id: 'puke',
            label: 'staticPages.signsAndSymptoms.child.fever.quiz1.options.option4',
            icon: 'Puke',
            correct: false,
          },
        ],
        feedback: {
          correct: 'staticPages.signsAndSymptoms.child.fever.quiz1.correct',
          wrong: 'staticPages.signsAndSymptoms.child.fever.quiz1.wrong',
        },
      },
      quizMCQ2: {
        mascot: 'askingQuickCheck',
        intro: 'staticPages.signsAndSymptoms.child.fever.quiz2.intro',
        question: 'staticPages.signsAndSymptoms.child.fever.quiz2.question',
        answer: 'staticPages.signsAndSymptoms.child.fever.quiz2.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'Warm',
            label: 'staticPages.signsAndSymptoms.child.fever.quiz2.options.option1',
            icon: 'Warm',
            correct: false,
          },
          {
            id: 'lie',
            label: 'staticPages.signsAndSymptoms.child.fever.quiz2.options.option2',
            icon: 'Lie',
            correct: false,
          },
          {
            id: 'NoCloth',
            label: 'staticPages.signsAndSymptoms.child.fever.quiz2.options.option3',
            icon: 'NoCloth',
            correct: false,
          },
          {
            id: 'LightCloth',
            label: 'staticPages.signsAndSymptoms.child.fever.quiz2.options.option4',
            icon: 'LightCloth',
            correct: true,
          },
        ],
        feedback: {
          correct: 'staticPages.signsAndSymptoms.child.fever.quiz2.correct',
          wrong: 'staticPages.signsAndSymptoms.child.fever.quiz2.wrong',
        },
      },
      quizBoolean: {
        mascot: 'askingQuickCheck',
        intro: 'staticPages.signsAndSymptoms.child.fever.quiz3.intro',
        question: 'staticPages.signsAndSymptoms.child.fever.quiz3.question',
        answer: 'staticPages.signsAndSymptoms.child.fever.quiz3.answer',
        options: [
          'staticPages.signsAndSymptoms.child.fever.quiz3.options.option1',
          'staticPages.signsAndSymptoms.child.fever.quiz3.options.option2',
        ],
        feedback: {
          correct: 'staticPages.signsAndSymptoms.child.fever.quiz3.correct',
          wrong: 'staticPages.signsAndSymptoms.child.fever.quiz3.wrong',
        },
      },
      finish: {
        type: 'finish',
        message: 'staticPages.signsAndSymptoms.child.fever.finish',
      },
    },
  },
  {
    id: 'vomiting',
    name: 'staticPages.signsAndSymptoms.child.vomiting.name',
    image: 'Vomiting',
    steps: {
      intro: {
        mascot: 'whatIs',
        text: 'staticPages.signsAndSymptoms.child.vomiting.intro',
        definition: 'staticPages.signsAndSymptoms.child.vomiting.definition',
      },
      whatHelps: {
        mascot: 'whatToDo',
        question: 'staticPages.signsAndSymptoms.child.vomiting.whatHelps.question',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'SipWater',
            label: 'staticPages.signsAndSymptoms.child.vomiting.whatHelps.options.option1',
            icon: 'SipWater',
          },
          {
            id: 'Milk',
            label: 'staticPages.signsAndSymptoms.child.vomiting.whatHelps.options.option2',
            icon: 'Milk',
          },
          {
            id: 'VomitingSleepy',
            label: 'staticPages.signsAndSymptoms.child.vomiting.whatHelps.options.option3',
            icon: 'VomitingSleepy',
          },
          {
            id: 'Sit',
            label: 'staticPages.signsAndSymptoms.child.vomiting.whatHelps.options.option4',
            icon: 'Sit',
          },
        ],
      },
      whenToSay: {
        mascot: 'whenToWorry',
        question: 'staticPages.signsAndSymptoms.child.vomiting.whenToSay.question',
        stepcolors: ['#FF2B26', '#FF8A00', '#FF8A00', '#FF2B26'],
        options: [
          {
            id: 'VomitingSleepy',
            label: 'staticPages.signsAndSymptoms.child.vomiting.whenToSay.options.option1',
            icon: 'VomitingSleepy',
          },
          {
            id: 'NoDrink',
            label: 'staticPages.signsAndSymptoms.child.vomiting.whenToSay.options.option2',
            icon: 'NoDrink',
          },
          {
            id: 'NoPee',
            label: 'staticPages.signsAndSymptoms.child.vomiting.whenToSay.options.option3',
            icon: 'NoPee',
          },
          {
            id: 'SunkenEyes',
            label: 'staticPages.signsAndSymptoms.child.vomiting.whenToSay.options.option4',
            icon: 'SunkenEyes',
          },
        ],
      },
      quizMCQ1: {
        mascot: 'askingQuickCheck',
        intro: 'staticPages.signsAndSymptoms.child.vomiting.quiz1.intro',
        question: 'staticPages.signsAndSymptoms.child.vomiting.quiz1.question',
        answer: 'staticPages.signsAndSymptoms.child.vomiting.quiz1.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'Cooked',
            label: 'staticPages.signsAndSymptoms.child.vomiting.quiz1.options.option1',
            icon: 'Cooked',
            correct: false,
          },
          {
            id: 'Vomit',
            label: 'staticPages.signsAndSymptoms.child.vomiting.quiz1.options.option2',
            icon: 'Vomit',
            correct: true,
          },
          {
            id: 'Sing',
            label: 'staticPages.signsAndSymptoms.child.vomiting.quiz1.options.option3',
            icon: 'Sing',
            correct: false,
          },
          {
            id: 'Tummy',
            label: 'staticPages.signsAndSymptoms.child.vomiting.quiz1.options.option4',
            icon: 'Tummy',
            correct: false,
          },
        ],
        feedback: {
          correct: 'staticPages.signsAndSymptoms.child.vomiting.quiz1.correct',
          wrong: 'staticPages.signsAndSymptoms.child.vomiting.quiz1.wrong',
        },
      },
      quizMCQ2: {
        mascot: 'askingQuickCheck',
        intro: 'staticPages.signsAndSymptoms.child.vomiting.quiz2.intro',
        question: 'staticPages.signsAndSymptoms.child.vomiting.quiz2.question',
        answer: 'staticPages.signsAndSymptoms.child.vomiting.quiz2.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'DrinkingWater',
            label: 'staticPages.signsAndSymptoms.child.vomiting.quiz2.options.option1',
            icon: 'DrinkingWater',
            correct: false,
          },
          {
            id: 'NoDrinking',
            label: 'staticPages.signsAndSymptoms.child.vomiting.quiz2.options.option2',
            icon: 'NoDrinking',
            correct: false,
          },
          {
            id: 'SmallSips',
            label: 'staticPages.signsAndSymptoms.child.vomiting.quiz2.options.option3',
            icon: 'SmallSips',
            correct: true,
          },
          {
            id: 'Hot',
            label: 'staticPages.signsAndSymptoms.child.vomiting.quiz2.options.option4',
            icon: 'Hot',
            correct: false,
          },
        ],
        feedback: {
          correct: 'staticPages.signsAndSymptoms.child.vomiting.quiz2.correct',
          wrong: 'staticPages.signsAndSymptoms.child.vomiting.quiz2.wrong',
        },
      },
      quizBoolean: {
        mascot: 'askingQuickCheck',
        intro: 'staticPages.signsAndSymptoms.child.vomiting.quiz3.intro',
        question: 'staticPages.signsAndSymptoms.child.vomiting.quiz3.question',
        answer: 'staticPages.signsAndSymptoms.child.vomiting.quiz3.answer',
        options: [
          'staticPages.signsAndSymptoms.child.vomiting.quiz3.options.option1',
          'staticPages.signsAndSymptoms.child.vomiting.quiz3.options.option2',
        ],
        feedback: {
          correct: 'staticPages.signsAndSymptoms.child.vomiting.quiz3.correct',
          wrong: 'staticPages.signsAndSymptoms.child.vomiting.quiz3.wrong',
        },
      },
      finish: {
        type: 'finish',
        message: 'staticPages.signsAndSymptoms.child.vomiting.finish',
      },
    },
  },
  {
    id: 'cough',
    name: 'staticPages.signsAndSymptoms.child.cough.name',
    image: 'Cough',
    steps: {
      intro: {
        mascot: 'whatIs',
        text: 'staticPages.signsAndSymptoms.child.cough.intro',
        definition: 'staticPages.signsAndSymptoms.child.cough.definition',
      },
      whatHelps: {
        mascot: 'whatToDo',
        question: 'staticPages.signsAndSymptoms.child.cough.whatHelps.question',
        stepcolors: ['#51A0CD', '#14C7C4', '#14C7C4', '#51A0CD'],
        options: [
          {
            id: 'Drink',
            label: 'staticPages.signsAndSymptoms.child.cough.whatHelps.options.option1',
            icon: 'Drink',
          },
          {
            id: 'KeepWarm',
            label: 'staticPages.signsAndSymptoms.child.cough.whatHelps.options.option2',
            icon: 'KeepWarm',
          },
          {
            id: 'SitDown',
            label: 'staticPages.signsAndSymptoms.child.cough.whatHelps.options.option3',
            icon: 'SitDown',
          },
          {
            id: 'BetterSleep',
            label: 'staticPages.signsAndSymptoms.child.cough.whatHelps.options.option4',
            icon: 'BetterSleep',
          },
        ],
      },
      whenToSay: {
        mascot: 'whenToWorry',
        question: 'staticPages.signsAndSymptoms.child.cough.whenToSay.question',
        stepcolors: ['#FF2B26', '#FF8A00', '#FF8A00', '#FF2B26'],
        options: [
          {
            id: 'BetterSleep',
            label: 'staticPages.signsAndSymptoms.child.cough.whenToSay.options.option1',
            icon: 'VomitingSleepy',
          },
          {
            id: 'Shivering',
            label: 'staticPages.signsAndSymptoms.child.cough.whenToSay.options.option2',
            icon: 'Shivering',
          },
          {
            id: 'HardBreathe',
            label: 'staticPages.signsAndSymptoms.child.cough.whenToSay.options.option3',
            icon: 'HardBreathe',
          },
          {
            id: 'CannotDrink',
            label: 'staticPages.signsAndSymptoms.child.cough.whenToSay.options.option4',
            icon: 'CannotDrink',
          },
        ],
      },
      quizMCQ1: {
        mascot: 'askingQuickCheck',
        intro: 'staticPages.signsAndSymptoms.child.cough.quiz1.intro',
        question: 'staticPages.signsAndSymptoms.child.cough.quiz1.question',
        answer: 'staticPages.signsAndSymptoms.child.cough.quiz1.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'Cooked',
            label: 'staticPages.signsAndSymptoms.child.cough.quiz1.options.option1',
            icon: 'Cooked',
            correct: false,
          },
          {
            id: 'CoughSleepy',
            label: 'staticPages.signsAndSymptoms.child.cough.quiz1.options.option2',
            icon: 'CoughSleepy',
            correct: false,
          },
          {
            id: 'CoughTwo',
            label: 'staticPages.signsAndSymptoms.child.cough.quiz1.options.option3',
            icon: 'CoughTwo',
            correct: true,
          },
          {
            id: 'Drink',
            label: 'staticPages.signsAndSymptoms.child.cough.quiz1.options.option4',
            icon: 'Drink',
            correct: false,
          },
        ],
        feedback: {
          correct: 'staticPages.signsAndSymptoms.child.cough.quiz1.correct',
          wrong: 'staticPages.signsAndSymptoms.child.cough.quiz1.wrong',
        },
      },
      quizMCQ2: {
        mascot: 'askingQuickCheck',
        intro: 'staticPages.signsAndSymptoms.child.cough.quiz2.intro',
        question: 'staticPages.signsAndSymptoms.child.cough.quiz2.question',
        answer: 'staticPages.signsAndSymptoms.child.cough.quiz2.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'Singing',
            label: 'staticPages.signsAndSymptoms.child.cough.quiz2.options.option1',
            icon: 'Singing',
            correct: false,
          },
          {
            id: 'Drink',
            label: 'staticPages.signsAndSymptoms.child.cough.quiz2.options.option2',
            icon: 'Drink',
            correct: true,
          },
          {
            id: 'Runshout',
            label: 'staticPages.signsAndSymptoms.child.cough.quiz2.options.option3',
            icon: 'Runshout',
            correct: false,
          },
          {
            id: 'LieFlat',
            label: 'staticPages.signsAndSymptoms.child.cough.quiz2.options.option4',
            icon: 'LieFlat',
            correct: false,
          },
        ],
        feedback: {
          correct: 'staticPages.signsAndSymptoms.child.cough.quiz2.correct',
          wrong: 'staticPages.signsAndSymptoms.child.cough.quiz2.wrong',
        },
      },
      quizBoolean: {
        mascot: 'askingQuickCheck',
        intro: 'staticPages.signsAndSymptoms.child.cough.quiz3.intro',
        question: 'staticPages.signsAndSymptoms.child.cough.quiz3.question',
        answer: 'staticPages.signsAndSymptoms.child.cough.quiz3.answer',
        options: [
          'staticPages.signsAndSymptoms.child.cough.quiz3.options.option1',
          'staticPages.signsAndSymptoms.child.cough.quiz3.options.option2',
        ],
        feedback: {
          correct: 'staticPages.signsAndSymptoms.child.cough.quiz3.correct',
          wrong: 'staticPages.signsAndSymptoms.child.cough.quiz3.wrong',
        },
      },
      finish: {
        type: 'finish',
        message: 'staticPages.signsAndSymptoms.child.cough.finish',
      },
    },
  },
  {
    id: 'diarrhoea',
    name: 'staticPages.signsAndSymptoms.child.diarrhoea.name',
    image: 'Diarrhoea',
    steps: {
      intro: {
        mascot: 'whatIs',
        text: 'staticPages.signsAndSymptoms.child.diarrhoea.intro',
        definition: 'staticPages.signsAndSymptoms.child.diarrhoea.definition',
      },
      whatHelps: {
        mascot: 'whatToDo',
        question: 'staticPages.signsAndSymptoms.child.diarrhoea.whatHelps.question',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'DrinkFluids',
            label: 'staticPages.signsAndSymptoms.child.diarrhoea.whatHelps.options.option1',
            icon: 'DrinkFluids',
          },
          {
            id: 'ORS',
            label: 'staticPages.signsAndSymptoms.child.diarrhoea.whatHelps.options.option2',
            icon: 'ORS',
          },
          {
            id: 'SleepBetter',
            label: 'staticPages.signsAndSymptoms.child.diarrhoea.whatHelps.options.option3',
            icon: 'SleepBetter',
          },
          {
            id: 'WashHands',
            label: 'staticPages.signsAndSymptoms.child.diarrhoea.whatHelps.options.option4',
            icon: 'WashHands',
          },
        ],
      },
      whenToSay: {
        mascot: 'whenToWorry',
        question: 'staticPages.signsAndSymptoms.child.diarrhoea.whenToSay.question',
        stepcolors: ['#FF2B26', '#FF8A00', '#FF8A00', '#FF2B26'],
        options: [
          {
            id: 'VerySleepy',
            label: 'staticPages.signsAndSymptoms.child.diarrhoea.whenToSay.options.option1',
            icon: 'VerySleepy',
          },
          {
            id: 'BloodyPoop',
            label: 'staticPages.signsAndSymptoms.child.diarrhoea.whenToSay.options.option2',
            icon: 'BloodyPoop',
          },
          {
            id: 'NoPeeing',
            label: 'staticPages.signsAndSymptoms.child.diarrhoea.whenToSay.options.option3',
            icon: 'NoPeeing',
          },
          {
            id: 'UnableToDrink',
            label: 'staticPages.signsAndSymptoms.child.diarrhoea.whenToSay.options.option4',
            icon: 'UnableToDrink',
          },
        ],
      },
      quizMCQ1: {
        mascot: 'askingQuickCheck',
        intro: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz1.intro',
        question: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz1.question',
        answer: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz1.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'NoPeeing',
            label: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz1.options.option1',
            icon: 'NoPeeing',
            correct: false,
          },
          {
            id: 'HardPoo',
            label: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz1.options.option2',
            icon: 'HardPoo',
            correct: false,
          },
          {
            id: 'WateryPoo',
            label: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz1.options.option3',
            icon: 'WateryPoo',
            correct: true,
          },
          {
            id: 'DiarrhoeaSing',
            label: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz1.options.option4',
            icon: 'DiarrhoeaSing',
            correct: false,
          },
        ],
        feedback: {
          correct: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz1.correct',
          wrong: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz1.wrong',
        },
      },
      quizMCQ2: {
        mascot: 'askingQuickCheck',
        intro: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz2.intro',
        question: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz2.question',
        answer: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz2.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'NoPeeing',
            label: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz2.options.option1',
            icon: 'NoPeeing',
            correct: false,
          },
          {
            id: 'ORS',
            label: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz2.options.option2',
            icon: 'ORS',
            correct: true,
          },
          {
            id: 'NoFood',
            label: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz2.options.option3',
            icon: 'NoFood',
            correct: false,
          },
          {
            id: 'DiarrhoeaRun',
            label: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz2.options.option4',
            icon: 'DiarrhoeaRun',
            correct: false,
          },
        ],
        feedback: {
          correct: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz2.correct',
          wrong: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz2.wrong',
        },
      },
      quizBoolean: {
        mascot: 'askingQuickCheck',
        intro: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz3.intro',
        question: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz3.question',
        answer: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz3.answer',
        options: [
          'staticPages.signsAndSymptoms.child.diarrhoea.quiz3.options.option1',
          'staticPages.signsAndSymptoms.child.diarrhoea.quiz3.options.option2',
        ],
        feedback: {
          correct: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz3.correct',
          wrong: 'staticPages.signsAndSymptoms.child.diarrhoea.quiz3.wrong',
        },
      },
      finish: {
        type: 'finish',
        message: 'staticPages.signsAndSymptoms.child.diarrhoea.finish',
      },
    },
  },
  {
    id: 'rash',
    name: 'staticPages.signsAndSymptoms.child.rash.name',
    image: 'RashTwo',
    steps: {
      intro: {
        mascot: 'whatIs',
        text: 'staticPages.signsAndSymptoms.child.rash.intro',
        definition: 'staticPages.signsAndSymptoms.child.rash.definition',
      },
      whatHelps: {
        mascot: 'whatToDo',
        question: 'staticPages.signsAndSymptoms.child.rash.whatHelps.question',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'KeepCool',
            label: 'staticPages.signsAndSymptoms.child.rash.whatHelps.options.option1',
            icon: 'KeepCool',
          },
          {
            id: 'DrinkMilk',
            label: 'staticPages.signsAndSymptoms.child.rash.whatHelps.options.option2',
            icon: 'DrinkMilk',
          },
          {
            id: 'WatchRash',
            label: 'staticPages.signsAndSymptoms.child.rash.whatHelps.options.option3',
            icon: 'WatchRash',
          },
          {
            id: 'CleanSkin',
            label: 'staticPages.signsAndSymptoms.child.rash.whatHelps.options.option4',
            icon: 'CleanSkin',
          },
        ],
      },
      whenToSay: {
        mascot: 'whenToWorry',
        question: 'staticPages.signsAndSymptoms.child.rash.whenToSay.question',
        stepcolors: ['#FF2B26', '#FF8A00', '#FF8A00', '#FF2B26'],
        options: [
          {
            id: 'RashShaking',
            label: 'staticPages.signsAndSymptoms.child.rash.whenToSay.options.option1',
            icon: 'RashShaking',
          },
          {
            id: 'RashNotAway',
            label: 'staticPages.signsAndSymptoms.child.rash.whenToSay.options.option2',
            icon: 'RashNotAway',
          },
          {
            id: 'SkinChanges',
            label: 'staticPages.signsAndSymptoms.child.rash.whenToSay.options.option3',
            icon: 'SkinChanges',
          },
          {
            id: 'VeryWeakRash',
            label: 'staticPages.signsAndSymptoms.child.rash.whenToSay.options.option4',
            icon: 'VeryWeakRash',
          },
        ],
      },
      quizMCQ1: {
        mascot: 'askingQuickCheck',
        intro: 'staticPages.signsAndSymptoms.child.rash.quiz1.intro',
        question: 'staticPages.signsAndSymptoms.child.rash.quiz1.question',
        answer: 'staticPages.signsAndSymptoms.child.rash.quiz1.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'QuizShaking',
            label: 'staticPages.signsAndSymptoms.child.rash.quiz1.options.option1',
            icon: 'QuizShaking',
            correct: false,
          },
          {
            id: 'Earpain',
            label: 'staticPages.signsAndSymptoms.child.rash.quiz1.options.option2',
            icon: 'Earpain',
            correct: false,
          },
          {
            id: 'TummyPain',
            label: 'staticPages.signsAndSymptoms.child.rash.quiz1.options.option3',
            icon: 'TummyPain',
            correct: false,
          },
          {
            id: 'SkinChanges',
            label: 'staticPages.signsAndSymptoms.child.rash.quiz1.options.option4',
            icon: 'SkinChanges',
            correct: true,
          },
        ],
        feedback: {
          correct: 'staticPages.signsAndSymptoms.child.rash.quiz1.correct',
          wrong: 'staticPages.signsAndSymptoms.child.rash.quiz1.wrong',
        },
      },
      quizMCQ2: {
        mascot: 'askingQuickCheck',
        intro: 'staticPages.signsAndSymptoms.child.rash.quiz2.intro',
        question: 'staticPages.signsAndSymptoms.child.rash.quiz2.question',
        answer: 'staticPages.signsAndSymptoms.child.rash.quiz2.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'SkinChanges',
            label: 'staticPages.signsAndSymptoms.child.rash.quiz2.options.option1',
            icon: 'SkinChanges',
            correct: false,
          },
          {
            id: 'PutOil',
            label: 'staticPages.signsAndSymptoms.child.rash.quiz2.options.option2',
            icon: 'PutOil',
            correct: false,
          },
          {
            id: 'KeepCool',
            label: 'staticPages.signsAndSymptoms.child.rash.quiz2.options.option3',
            icon: 'KeepCool',
            correct: true,
          },
          {
            id: 'Hot',
            label: 'staticPages.signsAndSymptoms.child.rash.quiz2.options.option4',
            icon: 'Hot',
            correct: false,
          },
        ],
        feedback: {
          correct: 'staticPages.signsAndSymptoms.child.rash.quiz2.correct',
          wrong: 'staticPages.signsAndSymptoms.child.rash.quiz2.wrong',
        },
      },
      quizBoolean: {
        mascot: 'askingQuickCheck',
        intro: 'staticPages.signsAndSymptoms.child.rash.quiz3.intro',
        question: 'staticPages.signsAndSymptoms.child.rash.quiz3.question',
        answer: 'staticPages.signsAndSymptoms.child.rash.quiz3.answer',
        options: [
          'staticPages.signsAndSymptoms.child.rash.quiz3.options.option1',
          'staticPages.signsAndSymptoms.child.rash.quiz3.options.option2',
        ],
        feedback: {
          correct: 'staticPages.signsAndSymptoms.child.rash.quiz3.correct',
          wrong: 'staticPages.signsAndSymptoms.child.rash.quiz3.wrong',
        },
      },
      finish: {
        type: 'finish',
        message: 'staticPages.signsAndSymptoms.child.rash.finish',
      },
    },
  },
  {
    id: 'ear-pain',
    name: 'staticPages.signsAndSymptoms.child.earpain.name',
    image: 'EarPain',
    steps: {
      intro: {
        mascot: 'whatIs',
        text: 'staticPages.signsAndSymptoms.child.earpain.intro',
        definition: 'staticPages.signsAndSymptoms.child.earpain.definition',
      },
      whatHelps: {
        mascot: 'whatToDo',
        question: 'staticPages.signsAndSymptoms.child.earpain.whatHelps.question',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'DryEar',
            label: 'staticPages.signsAndSymptoms.child.earpain.whatHelps.options.option1',
            icon: 'DryEar',
          },
          {
            id: 'CleanEar',
            label: 'staticPages.signsAndSymptoms.child.earpain.whatHelps.options.option2',
            icon: 'CleanEar',
          },
          {
            id: 'RestQuietly',
            label: 'staticPages.signsAndSymptoms.child.earpain.whatHelps.options.option3',
            icon: 'RestQuietly',
          },
          {
            id: 'TakeMedicine',
            label: 'staticPages.signsAndSymptoms.child.earpain.whatHelps.options.option4',
            icon: 'TakeMedicine',
          },
        ],
      },
      whenToSay: {
        mascot: 'whenToWorry',
        question: 'staticPages.signsAndSymptoms.child.earpain.whenToSay.question',
        stepcolors: ['#FF2B26', '#FF8A00', '#FF8A00', '#FF2B26'],
        options: [
          {
            id: 'FluidEar',
            label: 'staticPages.signsAndSymptoms.child.earpain.whenToSay.options.option1',
            icon: 'FluidEar',
          },
          {
            id: 'VeryWeak',
            label: 'staticPages.signsAndSymptoms.child.earpain.whenToSay.options.option2',
            icon: 'VeryWeak',
          },
          {
            id: 'SwollenEar',
            label: 'staticPages.signsAndSymptoms.child.earpain.whenToSay.options.option3',
            icon: 'SwollenEar',
          },
          {
            id: 'UnableToDrink2',
            label: 'staticPages.signsAndSymptoms.child.earpain.whenToSay.options.option4',
            icon: 'UnableToDrink2',
          },
        ],
      },
      quizMCQ1: {
        mascot: 'askingQuickCheck',
        intro: 'staticPages.signsAndSymptoms.child.earpain.quiz1.intro',
        question: 'staticPages.signsAndSymptoms.child.earpain.quiz1.question',
        answer: 'staticPages.signsAndSymptoms.child.earpain.quiz1.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'DryEar',
            label: 'staticPages.signsAndSymptoms.child.earpain.quiz1.options.option1',
            icon: 'DryEar',
            correct: true,
          },
          {
            id: 'PutWater',
            label: 'staticPages.signsAndSymptoms.child.earpain.quiz1.options.option2',
            icon: 'PutWater',
            correct: false,
          },
          {
            id: 'CleanEar',
            label: 'staticPages.signsAndSymptoms.child.earpain.quiz1.options.option3',
            icon: 'CleanEar',
            correct: false,
          },
          {
            id: 'PutOil2',
            label: 'staticPages.signsAndSymptoms.child.earpain.quiz1.options.option4',
            icon: 'PutOil2',
            correct: false,
          },
        ],
        feedback: {
          correct: 'staticPages.signsAndSymptoms.child.earpain.quiz1.correct',
          wrong: 'staticPages.signsAndSymptoms.child.earpain.quiz1.wrong',
        },
      },
      quizMCQ2: {
        mascot: 'askingQuickCheck',
        intro: 'staticPages.signsAndSymptoms.child.earpain.quiz2.intro',
        question: 'staticPages.signsAndSymptoms.child.earpain.quiz2.question',
        answer: 'staticPages.signsAndSymptoms.child.earpain.quiz2.answer',
        stepcolors: ['#14C7C4', '#51A0CD', '#51A0CD', '#14C7C4'],
        options: [
          {
            id: 'EarpainSing',
            label: 'staticPages.signsAndSymptoms.child.earpain.quiz2.options.option1',
            icon: 'EarpainSing',
            correct: false,
          },
          {
            id: 'EarPainFlat',
            label: 'staticPages.signsAndSymptoms.child.earpain.quiz2.options.option2',
            icon: 'EarPainFlat',
            correct: false,
          },
          {
            id: 'IgnoreIt',
            label: 'staticPages.signsAndSymptoms.child.earpain.quiz2.options.option3',
            icon: 'IgnoreIt',
            correct: false,
          },
          {
            id: 'TellGrownUp',
            label: 'staticPages.signsAndSymptoms.child.earpain.quiz2.options.option4',
            icon: 'TellGrownUp',
            correct: true,
          },
        ],
        feedback: {
          correct: 'staticPages.signsAndSymptoms.child.earpain.quiz2.correct',
          wrong: 'staticPages.signsAndSymptoms.child.earpain.quiz2.wrong',
        },
      },
      quizBoolean: {
        mascot: 'askingQuickCheck',
        intro: 'staticPages.signsAndSymptoms.child.earpain.quiz3.intro',
        question: 'staticPages.signsAndSymptoms.child.earpain.quiz3.question',
        answer: 'staticPages.signsAndSymptoms.child.earpain.quiz3.answer',
        options: [
          'staticPages.signsAndSymptoms.child.earpain.quiz3.options.option1',
          'staticPages.signsAndSymptoms.child.earpain.quiz3.options.option2',
        ],
        feedback: {
          correct: 'staticPages.signsAndSymptoms.child.earpain.quiz3.correct',
          wrong: 'staticPages.signsAndSymptoms.child.earpain.quiz3.wrong',
        },
      },
      finish: {
        type: 'finish',
        message: 'staticPages.signsAndSymptoms.child.earpain.finish',
      },
    },
  },
];

export const ADULTSIGNSANDSYMPTOMS = [
  {
    id: 'fever',
    name: 'staticPages.signsAndSymptoms.adult.fever.name',
    steps: {
      introduction: {
        qstn: 'staticPages.signsAndSymptoms.adult.fever.question',
        answer1: 'staticPages.signsAndSymptoms.adult.fever.answer1',
        answer2: 'staticPages.signsAndSymptoms.adult.fever.answer2',
      },
      whatToDo: {
        title: 'staticPages.signsAndSymptoms.adult.fever.whatToDo.title',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.fever.whatToDo.option1', icon: 'Water' },
          { label: 'staticPages.signsAndSymptoms.adult.fever.whatToDo.option2', icon: 'Cloth' },
          { label: 'staticPages.signsAndSymptoms.adult.fever.whatToDo.option3', icon: 'Sleeping' },
          { label: 'staticPages.signsAndSymptoms.adult.fever.whatToDo.option4', icon: 'Shirt' },
          { label: 'staticPages.signsAndSymptoms.adult.fever.whatToDo.option5', icon: 'Pills' },
        ],
      },
      whenToWorry: {
        title: 'staticPages.signsAndSymptoms.adult.fever.whenToWorry.title',
        title2: 'staticPages.signsAndSymptoms.adult.fever.whenToWorry.title2',
        options: [
          'staticPages.signsAndSymptoms.adult.fever.whenToWorry.option1',
          'staticPages.signsAndSymptoms.adult.fever.whenToWorry.option2',
          'staticPages.signsAndSymptoms.adult.fever.whenToWorry.option3',
          'staticPages.signsAndSymptoms.adult.fever.whenToWorry.option4',
        ],
      },
      faqs: {
        title: 'staticPages.signsAndSymptoms.adult.fever.faqs.title',
        title2: 'staticPages.signsAndSymptoms.adult.fever.faqs.title2',
        qstns: [
          {
            qstn: 'staticPages.signsAndSymptoms.adult.fever.faqs.qstn1',
            answer: 'staticPages.signsAndSymptoms.adult.fever.faqs.answer1',
          },
          {
            qstn: 'staticPages.signsAndSymptoms.adult.fever.faqs.qstn2',
            answer: 'staticPages.signsAndSymptoms.adult.fever.faqs.answer2',
          },
          {
            qstn: 'staticPages.signsAndSymptoms.adult.fever.faqs.qstn3',
            answer: 'staticPages.signsAndSymptoms.adult.fever.faqs.answer3',
          },
          {
            qstn: 'staticPages.signsAndSymptoms.adult.fever.faqs.qstn4',
            answer: 'staticPages.signsAndSymptoms.adult.fever.faqs.answer4',
          },
        ],
      },
      quickCheck1: {
        title: 'staticPages.signsAndSymptoms.adult.fever.quickCheck1.title',
        qstn: 'staticPages.signsAndSymptoms.adult.fever.quickCheck1.qstn',
        answer: 'staticPages.signsAndSymptoms.adult.fever.quickCheck1.answer',
        wrongAnswer: 'staticPages.signsAndSymptoms.adult.fever.quickCheck1.wrongAnswer',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.fever.quickCheck1.choice1', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.fever.quickCheck1.choice2', correct: true },
        ],
      },
      quickCheck2: {
        title: 'staticPages.signsAndSymptoms.adult.fever.quickCheck2.title',
        qstn: 'staticPages.signsAndSymptoms.adult.fever.quickCheck2.qstn',
        answer: 'staticPages.signsAndSymptoms.adult.fever.quickCheck2.answer',
        wrongAnswer: 'staticPages.signsAndSymptoms.adult.fever.quickCheck2.wrongAnswer',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.fever.quickCheck2.choice1', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.fever.quickCheck2.choice2', correct: true },
        ],
      },
      quickCheck3: {
        title: 'staticPages.signsAndSymptoms.adult.fever.quickCheck3.title',
        qstn: 'staticPages.signsAndSymptoms.adult.fever.quickCheck3.qstn',
        answer: 'staticPages.signsAndSymptoms.adult.fever.quickCheck3.answer',
        wrongAnswer: 'staticPages.signsAndSymptoms.adult.fever.quickCheck3.wrongAnswer',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.fever.quickCheck3.choice1', correct: true },
          { label: 'staticPages.signsAndSymptoms.adult.fever.quickCheck3.choice2', correct: false },
        ],
      },
      congratulations: {
        title: 'staticPages.signsAndSymptoms.adult.fever.congratulations.title',
        CTA: 'staticPages.signsAndSymptoms.adult.fever.congratulations.callToAction',
        path: 'staticPages.signsAndSymptoms.adult.fever.congratulations.path',
      },
    },
  },
  {
    id: 'diarrhoea',
    name: 'staticPages.signsAndSymptoms.adult.diarrhea.name',
    steps: {
      introduction: {
        qstn: 'staticPages.signsAndSymptoms.adult.diarrhea.question',
        answer: 'staticPages.signsAndSymptoms.adult.diarrhea.answer',
      },
      whatToDo: {
        title: 'staticPages.signsAndSymptoms.adult.diarrhea.whatToDo.title',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.diarrhea.whatToDo.option1', icon: 'ORS' },
          { label: 'staticPages.signsAndSymptoms.adult.diarrhea.whatToDo.option2', icon: 'BreastFeed' },
          { label: 'staticPages.signsAndSymptoms.adult.diarrhea.whatToDo.option3', icon: 'ORS' },
          { label: 'staticPages.signsAndSymptoms.adult.diarrhea.whatToDo.option4', icon: 'WashHands' },
          { label: 'staticPages.signsAndSymptoms.adult.diarrhea.whatToDo.option5', icon: 'WashDishes' },
        ],
      },
      whenToWorry: {
        title: 'staticPages.signsAndSymptoms.adult.diarrhea.whenToWorry.title',
        title2: 'staticPages.signsAndSymptoms.adult.diarrhea.whenToWorry.title2',
        options: [
          'staticPages.signsAndSymptoms.adult.diarrhea.whenToWorry.option1',
          'staticPages.signsAndSymptoms.adult.diarrhea.whenToWorry.option2',
          'staticPages.signsAndSymptoms.adult.diarrhea.whenToWorry.option3',
          'staticPages.signsAndSymptoms.adult.diarrhea.whenToWorry.option4',
          'staticPages.signsAndSymptoms.adult.diarrhea.whenToWorry.option5',
          'staticPages.signsAndSymptoms.adult.diarrhea.whenToWorry.option6',
        ],
      },
      faqs: {
        title: 'staticPages.signsAndSymptoms.adult.diarrhea.faqs.title',
        title2: 'staticPages.signsAndSymptoms.adult.diarrhea.faqs.title2',
        qstns: [
          {
            qstn: 'staticPages.signsAndSymptoms.adult.diarrhea.faqs.qstn1',
            answer: 'staticPages.signsAndSymptoms.adult.diarrhea.faqs.answer1',
          },
          {
            qstn: 'staticPages.signsAndSymptoms.adult.diarrhea.faqs.qstn2',
            answer: 'staticPages.signsAndSymptoms.adult.diarrhea.faqs.answer2',
          },
          {
            qstn: 'staticPages.signsAndSymptoms.adult.diarrhea.faqs.qstn3',
            answer: 'staticPages.signsAndSymptoms.adult.diarrhea.faqs.answer3',
          },
          {
            qstn: 'staticPages.signsAndSymptoms.adult.diarrhea.faqs.qstn4',
            answer: 'staticPages.signsAndSymptoms.adult.diarrhea.faqs.answer4',
          },
        ],
      },
      quickCheck1: {
        title: 'staticPages.signsAndSymptoms.adult.diarrhea.quickCheck1.title',
        qstn: 'staticPages.signsAndSymptoms.adult.diarrhea.quickCheck1.qstn',
        answer: 'staticPages.signsAndSymptoms.adult.diarrhea.quickCheck1.answer',
        wrongAnswer: 'staticPages.signsAndSymptoms.adult.diarrhea.quickCheck1.wrongAnswer',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.diarrhea.quickCheck1.choice1', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.diarrhea.quickCheck1.choice2', correct: true },
        ],
      },
      quickCheck2: {
        title: 'staticPages.signsAndSymptoms.adult.diarrhea.quickCheck2.title',
        qstn: 'staticPages.signsAndSymptoms.adult.diarrhea.quickCheck2.qstn',
        answer: 'staticPages.signsAndSymptoms.adult.diarrhea.quickCheck2.answer',
        wrongAnswer: 'staticPages.signsAndSymptoms.adult.diarrhea.quickCheck2.wrongAnswer',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.diarrhea.quickCheck2.choice1', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.diarrhea.quickCheck2.choice2', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.diarrhea.quickCheck2.choice3', correct: true },
          { label: 'staticPages.signsAndSymptoms.adult.diarrhea.quickCheck2.choice4', correct: false },
        ],
      },
      quickCheck3: {
        title: 'staticPages.signsAndSymptoms.adult.diarrhea.quickCheck3.title',
        qstn: 'staticPages.signsAndSymptoms.adult.diarrhea.quickCheck3.qstn',
        answer: 'staticPages.signsAndSymptoms.adult.diarrhea.quickCheck3.answer',
        wrongAnswer: 'staticPages.signsAndSymptoms.adult.diarrhea.quickCheck3.wrongAnswer',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.diarrhea.quickCheck3.choice1', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.diarrhea.quickCheck3.choice2', correct: true },
          { label: 'staticPages.signsAndSymptoms.adult.diarrhea.quickCheck3.choice3', correct: false },
        ],
      },
      congratulations: {
        title: 'staticPages.signsAndSymptoms.adult.diarrhea.congratulations.title',
        CTA: 'staticPages.signsAndSymptoms.adult.diarrhea.congratulations.callToAction',
        path: 'staticPages.signsAndSymptoms.adult.diarrhea.congratulations.path',
      },
    },
  },
  {
    id: 'vomiting',
    name: 'staticPages.signsAndSymptoms.adult.vomiting.name',
    steps: {
      introduction: {
        qstn: 'staticPages.signsAndSymptoms.adult.vomitting.question',
        answer: 'staticPages.signsAndSymptoms.adult.vomitting.answer',
      },
      whatToDo: {
        title: 'staticPages.signsAndSymptoms.adult.vomitting.whatToDo.title',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.vomitting.whatToDo.option1', icon: 'SipORS' },
          { label: 'staticPages.signsAndSymptoms.adult.vomitting.whatToDo.option2', icon: 'Sitting' },
          { label: 'staticPages.signsAndSymptoms.adult.vomitting.whatToDo.option3', icon: 'ORS' },
        ],
      },
      whenToWorry: {
        title: 'staticPages.signsAndSymptoms.adult.vomitting.whenToWorry.title',
        title2: 'staticPages.signsAndSymptoms.adult.vomitting.whenToWorry.title2',
        options: [
          'staticPages.signsAndSymptoms.adult.vomitting.whenToWorry.option1',
          'staticPages.signsAndSymptoms.adult.vomitting.whenToWorry.option2',
          'staticPages.signsAndSymptoms.adult.vomitting.whenToWorry.option3',
          'staticPages.signsAndSymptoms.adult.vomitting.whenToWorry.option4',
          'staticPages.signsAndSymptoms.adult.vomitting.whenToWorry.option5',
        ],
      },
      faqs: {
        title: 'staticPages.signsAndSymptoms.adult.vomitting.faqs.title',
        title2: 'staticPages.signsAndSymptoms.adult.vomitting.faqs.title2',
        qstns: [
          {
            qstn: 'staticPages.signsAndSymptoms.adult.vomitting.faqs.qstn1',
            answer: 'staticPages.signsAndSymptoms.adult.vomitting.faqs.answer1',
          },
          {
            qstn: 'staticPages.signsAndSymptoms.adult.vomitting.faqs.qstn2',
            answer: 'staticPages.signsAndSymptoms.adult.vomitting.faqs.answer2',
          },
          {
            qstn: 'staticPages.signsAndSymptoms.adult.vomitting.faqs.qstn3',
            answer: 'staticPages.signsAndSymptoms.adult.vomitting.faqs.answer3',
          },
          {
            qstn: 'staticPages.signsAndSymptoms.adult.vomitting.faqs.qstn4',
            answer: 'staticPages.signsAndSymptoms.adult.vomitting.faqs.answer4',
          },
        ],
      },
      quickCheck1: {
        title: 'staticPages.signsAndSymptoms.adult.vomitting.quickCheck1.title',
        qstn: 'staticPages.signsAndSymptoms.adult.vomitting.quickCheck1.qstn',
        answer: 'staticPages.signsAndSymptoms.adult.vomitting.quickCheck1.answer',
        wrongAnswer: 'staticPages.signsAndSymptoms.adult.vomitting.quickCheck1.wrongAnswer',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.vomitting.quickCheck1.choice1', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.vomitting.quickCheck1.choice2', correct: true },
        ],
      },
      quickCheck2: {
        title: 'staticPages.signsAndSymptoms.adult.vomitting.quickCheck2.title',
        qstn: 'staticPages.signsAndSymptoms.adult.vomitting.quickCheck2.qstn',
        answer: 'staticPages.signsAndSymptoms.adult.vomitting.quickCheck2.answer',
        wrongAnswer: 'staticPages.signsAndSymptoms.adult.vomitting.quickCheck2.wrongAnswer',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.vomitting.quickCheck2.choice1', correct: true },
          { label: 'staticPages.signsAndSymptoms.adult.vomitting.quickCheck2.choice2', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.vomitting.quickCheck2.choice3', correct: false },
        ],
      },
      quickCheck3: {
        title: 'staticPages.signsAndSymptoms.adult.vomitting.quickCheck3.title',
        qstn: 'staticPages.signsAndSymptoms.adult.vomitting.quickCheck3.qstn',
        answer: 'staticPages.signsAndSymptoms.adult.vomitting.quickCheck3.answer',
        wrongAnswer: 'staticPages.signsAndSymptoms.adult.vomitting.quickCheck3.wrongAnswer',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.vomitting.quickCheck3.choice1', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.vomitting.quickCheck3.choice2', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.vomitting.quickCheck3.choice3', correct: true },
          { label: 'staticPages.signsAndSymptoms.adult.vomitting.quickCheck3.choice4', correct: false },
        ],
      },
      congratulations: {
        title: 'staticPages.signsAndSymptoms.adult.vomitting.congratulations.title',
        CTA: 'staticPages.signsAndSymptoms.adult.vomitting.congratulations.callToAction',
        path: 'staticPages.signsAndSymptoms.adult.vomitting.congratulations.path',
      },
    },
  },
  {
    id: 'rash',
    name: 'staticPages.signsAndSymptoms.adult.rash.name',
    steps: {
      introduction: {
        qstn: 'staticPages.signsAndSymptoms.adult.rash.question',
        answer: 'staticPages.signsAndSymptoms.adult.rash.answer',
      },
      whatToDo: {
        title: 'staticPages.signsAndSymptoms.adult.rash.whatToDo.title',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.rash.whatToDo.option1', icon: 'CleanPlace' },
          { label: 'staticPages.signsAndSymptoms.adult.rash.whatToDo.option2', icon: 'GiveFood' },
          { label: 'staticPages.signsAndSymptoms.adult.rash.whatToDo.option3', icon: 'Rash' },
          { label: 'staticPages.signsAndSymptoms.adult.rash.whatToDo.option4', icon: 'Creams' },
          { label: 'staticPages.signsAndSymptoms.adult.rash.whatToDo.option5', icon: 'Medicine' },
        ],
      },
      whenToWorry: {
        title: 'staticPages.signsAndSymptoms.adult.rash.whenToWorry.title',
        title2: 'staticPages.signsAndSymptoms.adult.rash.whenToWorry.title2',
        options: [
          'staticPages.signsAndSymptoms.adult.rash.whenToWorry.option1',
          'staticPages.signsAndSymptoms.adult.rash.whenToWorry.option2',
          'staticPages.signsAndSymptoms.adult.rash.whenToWorry.option3',
          'staticPages.signsAndSymptoms.adult.rash.whenToWorry.option4',
          'staticPages.signsAndSymptoms.adult.rash.whenToWorry.option5',
        ],
      },
      faqs: {
        title: 'staticPages.signsAndSymptoms.adult.rash.faqs.title',
        title2: 'staticPages.signsAndSymptoms.adult.rash.faqs.title2',
        qstns: [
          {
            qstn: 'staticPages.signsAndSymptoms.adult.rash.faqs.qstn1',
            answer: 'staticPages.signsAndSymptoms.adult.rash.faqs.answer1',
          },
          {
            qstn: 'staticPages.signsAndSymptoms.adult.rash.faqs.qstn2',
            answer: 'staticPages.signsAndSymptoms.adult.rash.faqs.answer2',
          },
          {
            qstn: 'staticPages.signsAndSymptoms.adult.rash.faqs.qstn3',
            answer: 'staticPages.signsAndSymptoms.adult.rash.faqs.answer3',
          },
          {
            qstn: 'staticPages.signsAndSymptoms.adult.rash.faqs.qstn4',
            answer: 'staticPages.signsAndSymptoms.adult.rash.faqs.answer4',
          },
        ],
      },
      quickCheck1: {
        title: 'staticPages.signsAndSymptoms.adult.rash.quickCheck1.title',
        qstn: 'staticPages.signsAndSymptoms.adult.rash.quickCheck1.qstn',
        answer: 'staticPages.signsAndSymptoms.adult.rash.quickCheck1.answer',
        wrongAnswer: 'staticPages.signsAndSymptoms.adult.rash.quickCheck1.wrongAnswer',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.rash.quickCheck1.choice1', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.rash.quickCheck1.choice2', correct: true },
        ],
      },
      quickCheck2: {
        title: 'staticPages.signsAndSymptoms.adult.rash.quickCheck2.title',
        qstn: 'staticPages.signsAndSymptoms.adult.rash.quickCheck2.qstn',
        answer: 'staticPages.signsAndSymptoms.adult.rash.quickCheck2.answer',
        wrongAnswer: 'staticPages.signsAndSymptoms.adult.rash.quickCheck2.wrongAnswer',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.rash.quickCheck2.choice1', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.rash.quickCheck2.choice2', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.rash.quickCheck2.choice3', correct: true },
          { label: 'staticPages.signsAndSymptoms.adult.rash.quickCheck2.choice4', correct: false },
        ],
      },
      quickCheck3: {
        title: 'staticPages.signsAndSymptoms.adult.rash.quickCheck3.title',
        qstn: 'staticPages.signsAndSymptoms.adult.rash.quickCheck3.qstn',
        answer: 'staticPages.signsAndSymptoms.adult.rash.quickCheck3.answer',
        wrongAnswer: 'staticPages.signsAndSymptoms.adult.rash.quickCheck3.wrongAnswer',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.rash.quickCheck3.choice1', correct: true },
          { label: 'staticPages.signsAndSymptoms.adult.rash.quickCheck3.choice2', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.rash.quickCheck3.choice3', correct: false },
        ],
      },
      congratulations: {
        title: 'staticPages.signsAndSymptoms.adult.rash.congratulations.title',
        CTA: 'staticPages.signsAndSymptoms.adult.rash.congratulations.callToAction',
        path: 'staticPages.signsAndSymptoms.adult.rash.congratulations.path',
      },
    },
  },
  {
    id: 'cough',
    name: 'staticPages.signsAndSymptoms.adult.cough.name',
    steps: {
      introduction: {
        qstn: 'staticPages.signsAndSymptoms.adult.cough.question',
        answer: 'staticPages.signsAndSymptoms.adult.cough.answer',
      },
      whatToDo: {
        title: 'staticPages.signsAndSymptoms.adult.cough.whatToDo.title',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.cough.whatToDo.option1', icon: 'FoodDrink' },
          { label: 'staticPages.signsAndSymptoms.adult.cough.whatToDo.option2', icon: 'WarmClothes' },
          { label: 'staticPages.signsAndSymptoms.adult.cough.whatToDo.option3', icon: 'Resting' },
          { label: 'staticPages.signsAndSymptoms.adult.cough.whatToDo.option4', icon: 'HardBreathing' },
        ],
      },
      whenToWorry: {
        title: 'staticPages.signsAndSymptoms.adult.cough.whenToWorry.title',
        title2: 'staticPages.signsAndSymptoms.adult.cough.whenToWorry.title2',
        options: [
          'staticPages.signsAndSymptoms.adult.cough.whenToWorry.option1',
          'staticPages.signsAndSymptoms.adult.cough.whenToWorry.option2',
          'staticPages.signsAndSymptoms.adult.cough.whenToWorry.option3',
          'staticPages.signsAndSymptoms.adult.cough.whenToWorry.option4',
          'staticPages.signsAndSymptoms.adult.cough.whenToWorry.option5',
        ],
      },
      faqs: {
        title: 'staticPages.signsAndSymptoms.adult.cough.faqs.title',
        title2: 'staticPages.signsAndSymptoms.adult.cough.faqs.title2',
        qstns: [
          {
            qstn: 'staticPages.signsAndSymptoms.adult.cough.faqs.qstn1',
            answer: 'staticPages.signsAndSymptoms.adult.cough.faqs.answer1',
          },
          {
            qstn: 'staticPages.signsAndSymptoms.adult.cough.faqs.qstn2',
            answer: 'staticPages.signsAndSymptoms.adult.cough.faqs.answer2',
          },
          {
            qstn: 'staticPages.signsAndSymptoms.adult.cough.faqs.qstn3',
            answer: 'staticPages.signsAndSymptoms.adult.cough.faqs.answer3',
          },
        ],
      },
      quickCheck1: {
        title: 'staticPages.signsAndSymptoms.adult.cough.quickCheck1.title',
        qstn: 'staticPages.signsAndSymptoms.adult.cough.quickCheck1.qstn',
        answer: 'staticPages.signsAndSymptoms.adult.cough.quickCheck1.answer',
        wrongAnswer: 'staticPages.signsAndSymptoms.adult.cough.quickCheck1.wrongAnswer',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.cough.quickCheck1.choice1', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.cough.quickCheck1.choice2', correct: true },
        ],
      },
      quickCheck2: {
        title: 'staticPages.signsAndSymptoms.adult.cough.quickCheck2.title',
        qstn: 'staticPages.signsAndSymptoms.adult.cough.quickCheck2.qstn',
        answer: 'staticPages.signsAndSymptoms.adult.cough.quickCheck2.answer',
        wrongAnswer: 'staticPages.signsAndSymptoms.adult.cough.quickCheck2.wrongAnswer',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.cough.quickCheck2.choice1', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.cough.quickCheck2.choice2', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.cough.quickCheck2.choice3', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.cough.quickCheck2.choice4', correct: true },
        ],
      },
      quickCheck3: {
        title: 'staticPages.signsAndSymptoms.adult.cough.quickCheck3.title',
        qstn: 'staticPages.signsAndSymptoms.adult.cough.quickCheck3.qstn',
        answer: 'staticPages.signsAndSymptoms.adult.cough.quickCheck3.answer',
        wrongAnswer: 'staticPages.signsAndSymptoms.adult.cough.quickCheck3.wrongAnswer',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.cough.quickCheck3.choice1', correct: true },
          { label: 'staticPages.signsAndSymptoms.adult.cough.quickCheck3.choice2', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.cough.quickCheck3.choice3', correct: false },
        ],
      },
      congratulations: {
        title: 'staticPages.signsAndSymptoms.adult.cough.congratulations.title',
        CTA: 'staticPages.signsAndSymptoms.adult.cough.congratulations.callToAction',
        path: 'staticPages.signsAndSymptoms.adult.cough.congratulations.path',
      },
    },
  },
  {
    id: 'ear-pain',
    name: 'staticPages.signsAndSymptoms.adult.earpain.name',
    steps: {
      introduction: {
        qstn: 'staticPages.signsAndSymptoms.adult.earpain.question',
        answer: 'staticPages.signsAndSymptoms.adult.earpain.answer',
      },
      whatToDo: {
        title: 'staticPages.signsAndSymptoms.adult.earpain.whatToDo.title',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.earpain.whatToDo.option1', icon: 'DryEar' },
          { label: 'staticPages.signsAndSymptoms.adult.earpain.whatToDo.option2', icon: 'WipeOutside' },
          { label: 'staticPages.signsAndSymptoms.adult.earpain.whatToDo.option3', icon: 'InsideEar' },
          { label: 'staticPages.signsAndSymptoms.adult.earpain.whatToDo.option4', icon: 'Painkiller' },
          { label: 'staticPages.signsAndSymptoms.adult.earpain.whatToDo.option5', icon: 'OutsideEar' },
        ],
      },
      whenToWorry: {
        title: 'staticPages.signsAndSymptoms.adult.earpain.whenToWorry.title',
        title2: 'staticPages.signsAndSymptoms.adult.earpain.whenToWorry.title2',
        options: [
          'staticPages.signsAndSymptoms.adult.earpain.whenToWorry.option1',
          'staticPages.signsAndSymptoms.adult.earpain.whenToWorry.option2',
          'staticPages.signsAndSymptoms.adult.earpain.whenToWorry.option3',
          'staticPages.signsAndSymptoms.adult.earpain.whenToWorry.option4',
          'staticPages.signsAndSymptoms.adult.earpain.whenToWorry.option5',
          'staticPages.signsAndSymptoms.adult.earpain.whenToWorry.option6',
        ],
      },
      faqs: {
        title: 'staticPages.signsAndSymptoms.adult.earpain.faqs.title',
        title2: 'staticPages.signsAndSymptoms.adult.earpain.faqs.title2',
        qstns: [
          {
            qstn: 'staticPages.signsAndSymptoms.adult.earpain.faqs.qstn1',
            answer: 'staticPages.signsAndSymptoms.adult.earpain.faqs.answer1',
          },
          {
            qstn: 'staticPages.signsAndSymptoms.adult.earpain.faqs.qstn2',
            answer: 'staticPages.signsAndSymptoms.adult.earpain.faqs.answer2',
          },
          {
            qstn: 'staticPages.signsAndSymptoms.adult.earpain.faqs.qstn3',
            answer: 'staticPages.signsAndSymptoms.adult.earpain.faqs.answer3',
          },
          {
            qstn: 'staticPages.signsAndSymptoms.adult.earpain.faqs.qstn4',
            answer: 'staticPages.signsAndSymptoms.adult.earpain.faqs.answer4',
          },
        ],
      },
      quickCheck1: {
        title: 'staticPages.signsAndSymptoms.adult.earpain.quickCheck1.title',
        qstn: 'staticPages.signsAndSymptoms.adult.earpain.quickCheck1.qstn',
        answer: 'staticPages.signsAndSymptoms.adult.earpain.quickCheck1.answer',
        wrongAnswer: 'staticPages.signsAndSymptoms.adult.earpain.quickCheck1.wrongAnswer',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.earpain.quickCheck1.choice1', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.earpain.quickCheck1.choice2', correct: true },
        ],
      },
      quickCheck2: {
        title: 'staticPages.signsAndSymptoms.adult.earpain.quickCheck2.title',
        qstn: 'staticPages.signsAndSymptoms.adult.earpain.quickCheck2.qstn',
        answer: 'staticPages.signsAndSymptoms.adult.earpain.quickCheck2.answer',
        wrongAnswer: 'staticPages.signsAndSymptoms.adult.earpain.quickCheck2.wrongAnswer',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.earpain.quickCheck2.choice1', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.earpain.quickCheck2.choice2', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.earpain.quickCheck2.choice3', correct: false },
          { label: 'staticPages.signsAndSymptoms.adult.earpain.quickCheck2.choice4', correct: true },
        ],
      },
      quickCheck3: {
        title: 'staticPages.signsAndSymptoms.adult.earpain.quickCheck3.title',
        qstn: 'staticPages.signsAndSymptoms.adult.earpain.quickCheck3.qstn',
        answer: 'staticPages.signsAndSymptoms.adult.earpain.quickCheck3.answer',
        wrongAnswer: 'staticPages.signsAndSymptoms.adult.earpain.quickCheck3.wrongAnswer',
        options: [
          { label: 'staticPages.signsAndSymptoms.adult.earpain.quickCheck3.choice1', correct: true },
          { label: 'staticPages.signsAndSymptoms.adult.earpain.quickCheck3.choice2', correct: false },
        ],
      },
      congratulations: {
        title: 'staticPages.signsAndSymptoms.adult.earpain.congratulations.title',
        CTA: 'staticPages.signsAndSymptoms.adult.earpain.congratulations.callToAction',
        path: 'staticPages.signsAndSymptoms.adult.earpain.congratulations.path',
      },
    },
  },
];
